module.exports = __webpack_public_path__ + "images/category_lp/game_console/assessment_achievements/5@2x_e8cb92c5380fe17c0892a53af7d11024.png";